import React, { useState, useRef, useEffect, useCallback, useContext } from 'react';
import { Link } from 'react-router-dom';
import './SettingsPage.css';
import { FaArrowLeft } from 'react-icons/fa';
import Footer from './Footer';
import useOrientation from './useOrientation';
import { GameSettingsContext, GameSettingsProvider } from '../contexts/GameSettingsContext';

function SettingsPage() {
  const { timerDuration, setTimerDuration } = useContext(GameSettingsContext);
  const { isSoundEnabled, setIsSoundEnabled } = useContext(GameSettingsContext);

  const audioContextRef = useRef(null);
  const soundBuffersRef = useRef({});
  const [isAudioReady, setIsAudioReady] = useState(false);

  useEffect(() => {
    document.title = "Wunner - Settings";
  }, []);

  const orientation = useOrientation();

  const advertisementHeight = 25;
  const footerOffset = advertisementHeight + 10;

  const actualFooterOffset = orientation === 'portrait' ? footerOffset : 0;

  useEffect(() => {
    audioContextRef.current = new (window.AudioContext || window.webkitAudioContext)();

    const loadSound = async (name, url) => {
      try {
        const response = await fetch(url);
        const arrayBuffer = await response.arrayBuffer();
        const audioBuffer = await audioContextRef.current.decodeAudioData(arrayBuffer);
        soundBuffersRef.current[name] = audioBuffer;
      } catch (error) {
        console.error(`Error loading sound '${name}':`, error);
      }
    };

    const loadAllSounds = async () => {
      await Promise.all([
        loadSound('pass', '/pass-chime.wav'),
      ]);
      setIsAudioReady(true);
    };

    loadAllSounds();

    return () => {
      if (audioContextRef.current && audioContextRef.current.state !== 'closed') {
        audioContextRef.current.close().catch(e => console.error("Error closing AudioContext:", e));
      }
    };
  }, []);

  const playSound = useCallback((audioBuffer) => {
    if (!isAudioReady || !audioBuffer || !audioContextRef.current) {
      return;
    }

    if (audioContextRef.current.state === 'suspended') {
      audioContextRef.current.resume().catch(e => console.error("Error resuming AudioContext:", e));
    }

    const source = audioContextRef.current.createBufferSource();
    source.buffer = audioBuffer;
    source.connect(audioContextRef.current.destination);
    source.start(0);
  }, [isAudioReady]);

  const handleTimeChange = (event) => {
    setTimerDuration(parseInt(event.target.value, 10));
  };

  const handleSoundToggle = () => {
    if (!isSoundEnabled)
      playSound(soundBuffersRef.current.pass)
    setIsSoundEnabled(prev => !prev);
  };

  return (
    <div className="settings-page-container">
      <h1 className="settings-page-title">Settings</h1>

      <Link to="/" className="back-to-game-button">
        <span className="back-button-text">Back to Game</span>
        <FaArrowLeft className="back-button-icon" />
      </Link>

      <div className="settings-section">
        <h2 className="settings-section-title">Sound Settings</h2>
        <div className="toggle-container">
          <span className="toggle-label">Enable Sounds</span>
          <div className="toggle-switch">
            <input
              type="checkbox"
              id="soundToggle"
              checked={isSoundEnabled}
              onChange={handleSoundToggle}
            />
            <label htmlFor="soundToggle"></label>
            <div className="toggle-circle"></div>
          </div>
        </div>
      </div>

      <div className="settings-section">
        <h2 className="settings-section-title">Game Time (Seconds)</h2>
        <div className="radio-grid">
          {['30', '60', '90', '120'].map((time) => (
            <label key={time} className="radio-option-label">
              <input
                type="radio"
                name="gameTime"
                value={time}
                className="radio-option-input"
                checked={timerDuration === parseInt(time, 10)}
                onChange={handleTimeChange}
              />
              <span className="radio-option-text">{time}</span>
            </label>
          ))}
        </div>
      </div>
      <div className="ad-content-landscape">
        <div className="ad-container-landscape">
          {/* <img src="https://placehold.co/90x90?text=Ads" alt="Placeholder Image 1"></img> */}
          {/* <img src="https://placehold.co/90x90?text=Ad+2" alt="Placeholder Image 2"></img>
          <img src="https://placehold.co/90x90?text=Ad+3" alt="Placeholder Image 3"></img> */}
        </div>
      </div>
      <div className="ad-content-portrait">
        {/* <img src="https://placehold.co/195x40?text=Advertisement" alt="Placeholder Image 1"></img> */}
      </div>
      <Footer bottomOffset={actualFooterOffset} />
    </div>
  );
}

export default SettingsPage;
